/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect } from 'react'
import * as styles from './totals.tabs.styl'
import Tabs, { Tab, TabProps } from '../material/tabs'
import { keys, map } from 'lodash'
import Tile from '../tile'
import cx from 'classnames'
import { CSSSelector } from '@src/utils/css.selector.helper'

export interface TabItem extends TabProps {}

interface OwnProps<T> {
  id?: string
  items: TabItem[]
  activeTab: T
  onChange: (tab: T) => void
}

export type Props<T> = OwnProps<T>

export interface State {}

export function getTabNameWithCount(title: string, count: number) {
  return (
    <span className={styles.tabName}>
      <span
        className={cx(TotalsTabsComponent.CSSSelectors.titleSelector.value)}
      >
        {title}
      </span>
      <span
        className={cx(
          TotalsTabsComponent.CSSSelectors.countSelector.value,
          styles.count
        )}
      >
        ({count})
      </span>
    </span>
  )
}

function TotalsTabsComponent<T extends React.ReactText>(props: Props<T>) {
  const { id, onChange, items, activeTab } = props

  useEffect(() => {}, [props])

  function handleTabChange(tab) {
    if (typeof onChange === 'function') {
      onChange(tab)
    }
  }

  const tabsComponents = map(items || [], (tab, key) => (
    <Tab
      {...tab}
      classNameSelected={
        TotalsTabsComponent.CSSSelectors.selectedSelector.value
      }
      className={cx(
        TotalsTabsComponent.CSSSelectors.itemSelector.value,
        styles.tab
      )}
      style={{ padding: '6px 5px 2px 15px' }}
      key={key}
    />
  ))

  const hasTypes = keys(items || [])?.length > 0

  return (
    <Tile className={styles.tabs}>
      {hasTypes && activeTab && (
        <Tabs
          id={id}
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
        >
          {tabsComponents}
        </Tabs>
      )}
    </Tile>
  )
}

TotalsTabsComponent.CSSSelectors = {
  itemSelector: new CSSSelector('total-item'),
  countSelector: new CSSSelector('total-item-count'),
  titleSelector: new CSSSelector('total-item-title'),
  selectedSelector: new CSSSelector('total-item-selected')
}

export default React.memo(TotalsTabsComponent)
